import isNil from 'lodash/isNil'

export interface AddRoleOptions {
  hadExplicitRoles: boolean
  impliedRoleId?: string
}

/**
 * Adds a role to the drawer selection. A user with no granted role runs on an
 * implied role that any grant switches off, so their first added role keeps
 * the implied one as a real role.
 */
export const addRoleKeepingImplied = (
  current: string[],
  roleId: string,
  { hadExplicitRoles, impliedRoleId }: AddRoleOptions
): string[] => {
  if (current.includes(roleId)) return current
  if (
    !hadExplicitRoles &&
    current.length === 0 &&
    !isNil(impliedRoleId) &&
    impliedRoleId !== roleId
  ) {
    return [impliedRoleId, roleId]
  }
  return [...current, roleId]
}
